module.exports = __webpack_public_path__ + "static/media/delantal (10).1efb1630.jpg";